import { render, staticRenderFns } from "./IncorrectPhrase.vue?vue&type=template&id=958b8de6&"
import script from "./IncorrectPhrase.vue?vue&type=script&lang=js&"
export * from "./IncorrectPhrase.vue?vue&type=script&lang=js&"
import style0 from "./IncorrectPhrase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports